import { Component, EventEmitter, Output } from '@angular/core'

@Component({
    selector: 'app-scroll-to-top',
    imports: [],
    templateUrl: './scroll-to-top.component.html',
    styleUrls: ['./scroll-to-top.component.scss'],
})
export class ScrollToTopComponent {
    @Output() scrollToTopEvent = new EventEmitter<void>()

    scrollToTop(): void {
        this.scrollToTopEvent.emit()
    }
}
